var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescargar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 18.4108,
    width: 18,
    height: 1.78786,
    rx: 0.89393,
    fill: "#139DF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46319 13.4465V13.0848C7.46319 9.02929 7.46319 4.97282 7.46319 0.917273C7.46319 0.378075 7.78126 0.0756432 8.40702 0.00905266C9.04004 -0.0575379 9.61401 0.248594 9.67099 0.688832C9.68446 0.796116 9.67928 0.905251 9.67928 1.01346C9.67928 5.04219 9.67928 9.07091 9.67928 13.1006V13.4492C9.84297 13.3438 9.94554 13.2818 10.0419 13.2152C11.224 12.3995 12.4072 11.5847 13.5851 10.7662C13.8991 10.5479 14.2544 10.4184 14.7082 10.4924C15.5225 10.6256 15.8416 11.2804 15.3184 11.7318C15.2532 11.7882 15.1786 11.839 15.105 11.8899C13.2319 13.1838 11.3587 14.4786 9.48243 15.7707C8.87117 16.1924 8.28166 16.1979 7.68076 15.7836C5.77652 14.4721 3.87332 13.1607 1.97633 11.8446C1.28529 11.3655 1.5184 10.6608 2.41146 10.4998C2.88183 10.4147 3.24444 10.5498 3.56872 10.7745C4.75602 11.5995 5.9485 12.4199 7.13995 13.2421C7.22076 13.2976 7.30779 13.3484 7.46423 13.4483L7.46319 13.4465Z",
    fill: "#139DF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescargar);
export default __webpack_public_path__ + "static/media/Descargar.cda922a5b8178d2c61cfaeeae572c1d0.svg";
export { ForwardRef as ReactComponent };